import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';
import type { SectionColumnType } from '../../../../../models/enum/shared/section-column-type';
import { SectionColumnConfigDataValue } from 'src/app/models/enum/shared/section-column-config-data-value';
import { ColumnListLayoutModifierClass } from 'src/app/models/enum/shared/column-list-layout-types';

@Component({
  selector: 'app-column-product-tag-group',
  templateUrl: './column-product-tag-group.component.html',
  styleUrl: './column-product-tag-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnProductTagGroupComponent extends ColumnComponent {
  @Input() productTagGroupColumnType: SectionColumnType;
  @Input() displayFormat: SectionColumnConfigDataValue;
  @Input() columnListLayoutModifierClass: ColumnListLayoutModifierClass = null;
}
